import { render } from "./today.vue?vue&type=template&id=2ffc79fe&scoped=true"
import script from "./today.vue?vue&type=script&lang=js"
export * from "./today.vue?vue&type=script&lang=js"

import "./today.vue?vue&type=style&index=0&id=2ffc79fe&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffc79fe"]])

export default __exports__